import { FormField, Select, Text } from '@acast/decibel';
import moment from 'moment';
import React from 'react';
import Episode, { episodeHasCondition } from 'resources/episode';
import Modal from 'shared/components/modal';
import {
  createDefaultCondition,
  getCategoryDescription,
  getCategoryLabel,
  getEarlyReleaseDayCount,
  getEarlyReleaseDefaultEndDate,
  PermissionCategory,
} from 'shared/helpers/acast-plus';
import resourceProp from 'shared/helpers/resource-prop';

export default class AddConditionDialog extends React.Component {
  static propTypes = {
    episode: resourceProp(Episode),
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      condition: createDefaultCondition(props.episode),
    };
  }

  setCategory = ({ target: { value } }) => {
    this.setState(prevState => {
      const newEndDate =
        value === PermissionCategory.EARLY_RELEASE
          ? getEarlyReleaseDefaultEndDate(prevState.condition)
          : null;

      return {
        condition: Object.assign(prevState.condition, {
          category: value,
          endDate: newEndDate,
        }),
      };
    });
  };

  getCategorySelect = () => {
    const { episode } = this.props;
    const { condition } = this.state;
    const availableConditions = [];

    if (!episodeHasCondition(episode, PermissionCategory.EXCLUSIVE_CONTENT)) {
      availableConditions.push({
        value: PermissionCategory.EXCLUSIVE_CONTENT,
        label: getCategoryLabel(PermissionCategory.EXCLUSIVE_CONTENT),
      });
    }

    if (!episodeHasCondition(episode, PermissionCategory.EARLY_RELEASE)) {
      availableConditions.push({
        value: PermissionCategory.EARLY_RELEASE,
        label: getCategoryLabel(PermissionCategory.EARLY_RELEASE),
      });
    }

    return (
      <FormField label="Condition">
        <Select value={condition.category} onChange={this.setCategory}>
          {availableConditions.map(option => (
            <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </FormField>
    );
  };

  getCategoryDescription = () => {
    const { condition } = this.state;
    return <Text variant="body2">{getCategoryDescription(condition.category)}</Text>;
  };

  getConditionInputs = () => {
    const { condition } = this.state;
    if (condition.category === PermissionCategory.EARLY_RELEASE) {
      const options = [];

      for (let i = 1, l = 31; i < l; i++) {
        options.push({
          value: i,
          label: `${i} ${i === 1 ? 'day' : 'days'} after publish`,
        });
      }

      return (
        <FormField label="Available to everyone">
          <Select value={getEarlyReleaseDayCount(condition)} onChange={this.setEarlyReleaseEndDate}>
            {options.map(option => (
              <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </FormField>
      );
    }
    return null;
  };

  setEarlyReleaseEndDate = ({ target: { value } }) => {
    const dayCount = parseInt(value, 10);
    if (!isNaN(dayCount)) {
      this.setState(prevState => {
        const startDate = moment(prevState.condition.startDate);
        const newEndDate = startDate.add(dayCount, 'days');

        return {
          condition: Object.assign(prevState.condition, {
            endDate: newEndDate.toISOString(),
          }),
        };
      });
    } else {
      throw new Error('End date is not a number');
    }
  };

  render() {
    return (
      <Modal
        title="Add New Condition"
        onDismiss={this.props.onDismiss}
        dialog={
          <>
            {this.getCategorySelect()}
            {this.getCategoryDescription()}
            {this.getConditionInputs()}
          </>
        }
        actions={[
          { name: 'Cancel', value: false, variant: 'tertiary' },
          { name: 'Add condition', value: this.state.condition, variant: 'primary' },
        ]}
      />
    );
  }
}
